import { Component, OnDestroy, OnInit } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { Subscription } from 'rxjs';
import { CookieService } from 'ngx-cookie-service';
import { Router, ActivatedRoute, NavigationEnd } from '@angular/router';

@Component({
    selector: 'app-root',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.scss']
})
export class AppComponent implements OnInit, OnDestroy {
    private unsubscribe: Subscription[] = [];

    constructor(private translate: TranslateService, private cookieService: CookieService, private router: Router, private activatedRoute: ActivatedRoute) {
        this.router.routeReuseStrategy.shouldReuseRoute = () => false;
        this.unsubscribe.push(this.router.events.subscribe((event) => {
            if (event instanceof NavigationEnd) {
                // Trick the Router into believing it's last link wasn't previously loaded
                this.router.navigated = false;
            }
        }));
    }

    ngOnInit() {
        let lang = 'en';

        if(navigator.language.includes('fr')) {
            lang = 'fr'
        }

        this.translate.addLangs(['fr', 'en']);
        this.translate.setDefaultLang(lang);
        this.translate.currentLang = lang;
        this.translate.use(lang)
        this.cookieService.set('language', lang);

        // if (this.cookieService.get('language')) {
        //     this.translate.setDefaultLang(this.cookieService.get('language'));
        //     this.translate.currentLang = this.cookieService.get('language');
        // }
        // else {
        //     this.translate.addLangs(['fr', 'en']);
        //     this.translate.setDefaultLang('en');
        //     this.translate.currentLang = lang;
        //     this.translate.use(lang)
        //     this.cookieService.set('language', lang);
        // }
    }

    ngOnDestroy() {
        this.unsubscribe.forEach(s => s.unsubscribe());
    }

    title = '';
}

